module.exports = __webpack_public_path__ + "e7bcd47f68c77dae4f93d42da2670160.png";